import { QuoteVariableType } from '@sequencehq/quote-content'

export const quoteVariableLabel: Record<QuoteVariableType, string> = {
  CURRENCY: 'Currency',
  CUSTOMER_NAME: 'Customer name',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  DURATION: 'Contract duration',
  CUSTOMER_ADDRESS: 'Customer address',
  CUSTOMER_COUNTRY: 'Customer country',
  QUOTE_OWNER: 'Quote owner',
  PAYMENT_TERMS: 'Payment terms',
  RECIPIENTS: 'Recipients'
}
